import React from 'react';
import PropTypes from 'prop-types';
import {defaultsDeep, get} from 'lodash';
import {I18n} from 'react-redux-i18n';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import ResetPasswordInput from '../component/ResetPasswordInput';
import AdminConfigSection from '../component/AdminConfigSection';

export default class DVRToolkitPasswordSection extends React.Component {

  static propTypes = {
    settings: PropTypes.shape({
      install: PropTypes.shape({
        userName: PropTypes.string,
        password: PropTypes.string
      })
    }),
    system: PropTypes.shape({
      settings: PropTypes.shape({
        userName: PropTypes.shape({
          mode: PropTypes.oneOf(['cid', 'username'])
        })
      })
    }),
    onChange: PropTypes.func
  }

  static defaulProps = {
    settings: {
      install: {
        userName: '',
        password: ''
      }
    },
    system: {
      settings: {
        userName: {
          mode: 'cid'
        }
      }
    },
    onChange: () => {}
  }

  state = {
    lastPasswordFromProps: '',
    password: ''
  }

  constructor(props) {
    super(defaultsDeep(props, DVRToolkitPasswordSection.defaulProps));
  }
  
  getUsernameLabel() {
    const userNameMode = get(this.props, 'system.settings.userName.mode', 'cid');

    if (userNameMode === 'cid') {
      return I18n.t('page.admin.form.dvrToolkitPassword.cid');
    }

    return I18n.t('page.admin.form.dvrToolkitPassword.username');
  }

  handlePasswordChange = ({value: password, valid}) => {
    this.setState({
      password
    });

    this.props.onChange({
      install: {
        password
      }
    }, {
      errors: {
        dvrToolkitPassword: !valid
      }
    });
  }

  render() {
    const {userName} = this.props.settings.install;
    const {password} = this.state;

    return (
      <AdminConfigSection
        id="dvrToolkitPasswordPanel"
        title="page.admin.form.dvrToolkitPassword.title"
      >
         <Grid container className="admin__overspeedrow">
            <Grid item md={3}>
              <div className="admin__fieldinfo">
                <TextField
                  type="text"
                  value={userName}
                  label={this.getUsernameLabel()}
                  disabled
                />
              </div>
            </Grid>
            <Grid item md={4}>
              <div className="admin__fieldinfo">
                <ResetPasswordInput
                  label="page.admin.form.dvrToolkitPassword.password"
                  value={password}
                  onChange={this.handlePasswordChange}
                  error={false}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="admin__info-cont">
                <Icon className="admin__info-icon admin__info-icon-top">info</Icon>
                {I18n.t('page.admin.form.dvrToolkitPassword.infoMessage')}
              </div>
            </Grid>
          </Grid>
      </AdminConfigSection>
    );
  }

  static getDerivedStateFromProps(props, state) {
    const currentPassword = get(props, 'settings.install.password', '');

    if (currentPassword === state.lastPasswordFromProps) {
      return null;
    }

    return {
      lastPasswordFromProps: currentPassword,
      password: currentPassword
    };
  }

}